import { Icd } from "@/@types/sintegrada/sintegradaServerApi/Icd";

import { getSintegradaServerApi } from "@/services/api";

type Params = {
	ibgeCode?: string;
	page?: number;
	per_page?: number;
	search?: string;
	signal?: AbortSignal;
};

type ApiResponse = {
	data: Icd[];
	meta: {
		current_page: number;
		last_page: number;
		per_page: number;
		total: number;
		from: number;
		to: number;
	};
	links: {
		first: string;
		last: string;
		prev?: string;
		next?: string;
	};
	pagination: {
		current_page: number;
		per_page: number;
		total: number;
		last_page: number;
		from: number;
		to: number;
	};
};

export async function getIcds({ ibgeCode, signal, ...params }: Params) {
	const url = "/diagnostic-hypothesis/filters/cids";

	const { data } = await getSintegradaServerApi().get<ApiResponse>(url, {
		ibgeCode,
		...params,
		signal,
	});

	return data || defaultIcdResponse;
}

const defaultIcdResponse = {
	data: [],
	meta: { current_page: 1, last_page: 1, per_page: 100, total: 0, from: 1, to: 0 },
	links: {},
	pagination: {},
};
